import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const ProductPickerHeader = _ref => {
  let {
    className,
    style
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("./i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      padding: '0 15px'
    }, style]
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      padding: '8px 0',
      color: theme.colors.charcoal700
    }, theme.typography.heading4]
  }, T.translate('AVAILABLE_PROJECT')), /*#__PURE__*/React.createElement(Divider, null));
};
ProductPickerHeader.displayName = 'ProductPickerHeader';
ProductPickerHeader.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string
};
export default ProductPickerHeader;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "ProductPickerHeader___StyledDiv2",
  componentId: "sc-t16s68-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=ProductPickerHeader.js.map